const styles = (theme) => ({
  card: {
    minWidth: 275,
    position: 'absolute',
  },
  label: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing(1),
    // marginLeft: '300px'
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  iconSmall: {
    fontSize: 15,
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

export default styles
